module.exports = __webpack_public_path__ + "na.e60de663.svg";